import React, { useMemo } from "react";

import { Row, Space, Checkbox, Col, Collapse, Badge } from "antd";
import { _Filter_Types, _Filters_Handlers, FilterActions } from "../";
import xor from "lodash/xor";
import { TenantCheckbox } from ".";
const SelectedPanelColor = "#bae7ff";
const { Panel } = Collapse;

function CustomCheckbox({
	_Label,
	_ApiTag,
	_Childrens,
	value,
	_Other_Lable,
	_Other_ApiTag,
	_SectionApiTag,
	defaultActiveKey,
	dispatch,
	_extra,
	tenant
}) {
	value = value?.filter(item => {
		return _Childrens
			?.map(({ _ApiTag }) => {
				return _ApiTag;
			})
			?.includes(item);
	});
	let SelectAllChecked = useMemo(() => {
		return value
			? xor(
					value,
					_Childrens.map(({ _ApiTag }) => _ApiTag)
			  ).length === 0 || value.includes(_Other_ApiTag)
			: false;
	}, [value, _Childrens, _Other_ApiTag]);

	return (
		<>
			<Collapse
				defaultActiveKey={defaultActiveKey}
				onChange={() => {}}
				style={{
					"background-color": value?.length > 0 ? SelectedPanelColor : "#f0f0f0f0"
				}}
			>
				<Panel
					extra={
						<>
							{_extra && (
								<>
									<TenantCheckbox
										tenant={tenant}
										_ApiTag={_ApiTag}
										_extra={_extra}
										dispatch={dispatch}
									/>
								</>
							)}

							{_Other_Lable && (
								<Checkbox
									checked={value ? value.includes(_Other_ApiTag) : false}
									onChange={() =>
										_Filters_Handlers[_Filter_Types.Checkbox]({
											dispatch,
											_SectionApiTag,
											_ApiTag,
											_Child_ApiTag: _Other_ApiTag
										})
									}
								>
									{_Other_Lable}
								</Checkbox>
							)}
							<Checkbox
								checked={SelectAllChecked}
								onChange={() => {
									dispatch({
										type: FilterActions.SelectedAll,
										value: {
											_SectionApiTag,
											_ApiTag,
											_Child_ApiTag: _Childrens.map(({ _ApiTag }) => _ApiTag)
										}
									});
								}}
							>
								Select All
							</Checkbox>
							<Badge
								count={value?.includes(_Other_ApiTag) ? _Childrens.length + 1 : value?.length ?? 0}
								style={{ backgroundColor: "#1890ff " }}
							/>
						</>
					}
					header={_Label}
					key={_ApiTag}
				>
					<Space direction="vertical" size="small" style={{ display: "flex" }} align="left">
						{_Childrens.map(({ _ApiTag: _Child_ApiTag, _Label: _Child_Label }) => {
							return (
								<Row>
									<Col>
										<Checkbox
											onChange={() =>
												_Filters_Handlers[_Filter_Types.Checkbox]({
													dispatch,
													_SectionApiTag,
													_ApiTag,
													_Child_ApiTag
												})
											}
											checked={value?.includes(_Child_ApiTag) || value?.includes(_Other_ApiTag)}
										>
											{_Child_Label}
										</Checkbox>
									</Col>
								</Row>
							);
						})}
					</Space>
				</Panel>
			</Collapse>
		</>
	);
}

export default CustomCheckbox;
